import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import filter from "lodash/filter";

import { filterOutNodesThatAreNotVisible } from "../../components/NodeChildrenRenderer";
import {
  IssueId,
  SelfServeContext,
  SelfServeNode,
  SelfServeNodes,
} from "../../types";
import { getNodesThatCanBeRendered } from "../../utils/getNodesThatCanBeRendered";

type NodeVisibility = Record<IssueId, boolean>;

export const getAllVisibleNodes = async (
  context: SelfServeContext
): Promise<SelfServeNode[]> => {
  const { tree } = context;
  let nodesConditionalVisibility: NodeVisibility = {};
  let allVisibilityPromises: Promise<boolean>[] = [];

  for (const nodeId in tree) {
    const node = tree[nodeId] as SelfServeNode;
    if (node.children && nodesConditionalVisibility[node.id] !== false) {
      const visibilityPromises = getNodesThatCanBeRendered(tree, node.children)
        .filter((node) => isNotUndefined(node.isNodeVisible))
        .map((node) => {
          return node.isNodeVisible!(context).then((isVisible) => {
            nodesConditionalVisibility = updateNodeVisibility(
              tree,
              node,
              isVisible,
              nodesConditionalVisibility
            );
            return isVisible;
          });
        });
      allVisibilityPromises = [...allVisibilityPromises, ...visibilityPromises];
    }
  }

  return Promise.all(allVisibilityPromises).then(() => {
    return filter(tree, (node) =>
      filterOutNodesThatAreNotVisible(node, nodesConditionalVisibility)
    );
  });
};

// @ts-prune-ignore-next
export const updateNodeVisibility = (
  tree: SelfServeNodes,
  node: SelfServeNode | undefined,
  isVisible: boolean,
  nodeVisibility: NodeVisibility
): NodeVisibility => {
  if (!node) {
    return nodeVisibility;
  }
  if (!isVisible) {
    nodeVisibility = {
      ...nodeVisibility,
      [node.id]: false,
    };
    if (node.children) {
      for (const childrenNodeId of node.children) {
        nodeVisibility = {
          ...nodeVisibility,
          [childrenNodeId]: false,
        };
        nodeVisibility = updateNodeVisibility(
          tree,
          tree[childrenNodeId],
          false,
          nodeVisibility
        );
      }
    } else {
      return {
        ...nodeVisibility,
        [node.id]: false,
      };
    }
  }
  return {
    ...nodeVisibility,
    [node.id]: isVisible,
  };
};
